module.exports = __webpack_public_path__ + "static/media/founder.7312169e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/founder.png
// module id = 474
// module chunks = 0